import { Skeleton } from '@mui/material';
import RTMSelectedAndTableSkeleton from './RTMSelectedAndTableSkeleton';

const RTMSkeleton = () => {
  return (
    <div style={{ display: 'flex', height: '100%', width: '100%', overflow: 'hidden' }}>
      
      {/* Left Panel (Families / Product Types) */}
      <div style={{ width: '25%', maxWidth: '350px', padding: '0 20px 20px 0', boxSizing: 'border-box' }}>
        {/* Title Families with icon aligned to the right */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px' }}>
          <Skeleton variant='text' width={100} height={25} />
          <Skeleton variant='circular' width={15} height={15} />
        </div>

        {/* List of Families (Checkbox + Label) */}
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={`family-${i}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <Skeleton
              variant='rectangular'
              width={16}
              height={16}
              style={{ marginRight: '10px', marginLeft: '15px', borderRadius: '3px' }}
            />
            <Skeleton variant='text' width={80} height={20} />
          </div>
        ))}

        {/* Separator */}
        <hr style={{ border: 'none', margin: '20px 0' }} />

        {/* Title Product Types with icon aligned to the right */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px' }}>
          <Skeleton variant='text' width={120} height={25} />
        </div>

        {/* List of Product Types (Checkbox + Label) */}
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={`types-${i}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <Skeleton
              variant='rectangular'
              width={16}
              height={16}
              style={{ marginRight: '10px', marginLeft: '15px', borderRadius: '3px' }}
            />
            <Skeleton variant='text' width={140} height={20} />
          </div>
        ))}

        {/* Separator */}
        <hr style={{ border: 'none', margin: '20px 0' }} />

        {/* Title Product Types with icon aligned to the right */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px' }}>
          <Skeleton variant='text' width={120} height={25} />
        </div>

        {/* List of Product Types (Checkbox + Label) */}
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={`types-${i}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <Skeleton
              variant='rectangular'
              width={16}
              height={16}
              style={{ marginRight: '10px', marginLeft: '15px', borderRadius: '3px' }}
            />
            <Skeleton variant='text' width={140} height={20} />
          </div>
        ))}
      </div>
      {/* Right Section */}
      <RTMSelectedAndTableSkeleton />
    </div>
  );
};

export default RTMSkeleton;
